import { render, staticRenderFns } from "./traduction.vue?vue&type=template&id=5e78cce3&"
import script from "./traduction.vue?vue&type=script&lang=js&"
export * from "./traduction.vue?vue&type=script&lang=js&"
import style0 from "./traduction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports